<template>
    <!-- 发布 -->
    <div class="">
      <v-dialog
        class="del"
        name="dialog2"
        v-model="isShow"
        :title="this.status == 1 ? dialogTitleno : dialogTitleyes"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.sure"
      >
      <span> {{ this.status == 1 ? '确定要撤销发布此产品吗？' : '确定要发布此产品吗？'}}</span>
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    productName:{
    },
    productId:{
    },
    status:{
    }

    },
    data() {
      return {
        sure:"确认",
        isShow:false,
        dialogTitleyes: "确认发布产品",
        dialogTitleno: "确认撤销发布"
      };
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){

      },
      handleConfirm() {
        const subData = {
         id: Number(this.productId),
         publish_status: this.status == 1 ? 2 : 1,
        };
        this.$put(`/td/td-iot-api/iot/product/publish/v1`, subData ,false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('changStatus',subData.publish_status )
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
      this.$emit('getData')
      this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
